import { useEffect, useState } from "react";
import { MapPin, Globe, Mail, UserCheck, Check, Loader2 } from "lucide-react";

const STEPS = [
  [MapPin, "Finner bedrifter i området", 0],
  [Globe, "Sjekker nettsider", 4],
  [Mail, "Leter etter e-postadresser", 10],
  [UserCheck, "Henter kontaktperson fra Brønnøysund", 18],
];
const TIPS = [
  "Søk uten treff er gratis.",
  "Du godkjenner hver e-post før noe sendes.",
  "Pro fjerner bedrifter du allerede har funnet.",
  "Tips: velg færre bransjer for mer treffsikre resultater.",
];

export const SearchProgress = () => {
  const [sec, setSec] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setSec((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, []);
  const pct = Math.min(95, Math.round(100 * (1 - Math.exp(-sec / 14))));
  return (
    <div data-testid="search-progress" className="sm:col-span-2 rounded-xl border border-border bg-secondary/50 p-4">
      <div className="flex items-center justify-between text-xs font-semibold text-muted-foreground">
        <span>Søket pågår …</span><span data-testid="search-progress-seconds">{sec} s</span>
      </div>
      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-border">
        <div className="h-full rounded-full bg-primary transition-[width] duration-1000" style={{ width: `${pct}%` }} />
      </div>
      <ul className="mt-3 grid gap-1.5 sm:grid-cols-2">
        {STEPS.map(([Icon, label, at], i) => {
          const next = STEPS[i + 1]?.[2] ?? Infinity;
          const done = sec >= next, active = sec >= at && !done;
          return (
            <li key={label} className={`flex items-center gap-2 text-sm transition-opacity ${sec >= at ? "opacity-100" : "opacity-40"}`}>
              {done ? <Check className="h-4 w-4 text-[#16A34A]" /> : active ? <Loader2 className="h-4 w-4 animate-spin text-primary" /> : <Icon className="h-4 w-4" />}
              {label}
            </li>
          );
        })}
      </ul>
      <p className="mt-3 text-xs text-muted-foreground">{TIPS[Math.floor(sec / 6) % TIPS.length]}</p>
    </div>
  );
};
